import { Route, Redirect } from "react-router-dom"
import { useAppSelector } from "./hooks"

function PrivateRoute({ children, ...rest }) {
  const { userInfo, menu } = useAppSelector((state) => state["appReducer"])

  return (
    <Route
      {...rest}
      render={({ location }) => {
        const _pathName = location.pathname.split("/")[1].toLowerCase()

        const menuItemExist = menu.isAuth
          ? menu.items.find(
              (menuItem) =>
                menuItem.pageId === _pathName ||
                menuItem.items.find((i) => i.pageId.toLowerCase() === _pathName)
            )
          : true

        return userInfo.authenticated && menuItemExist ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: userInfo.authenticated ? "/" : "/login",
              state: { from: location }
            }}
          />
        )
      }}
    />
  )
}

export default PrivateRoute
